<template>
  <div>
    <px-view-header title="Notas de Entrada" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-tipo-nota-entrada-list-header :on-click-refresh="onClickRefresh"
                                      :on-change-filter="onChangeFilter" />
    <px-tipo-nota-entrada-list :notas-entrada="notasEntrada"
                               :loading="loading"
                               :on-change-options="onChangeOptions"
                               :options-list="optionsList"
                               @remove="onRemove"
                               @update="onClickRefresh"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import TipoNotaEntradaService from './tipo-nota-entrada-service';
import TipoNotaEntradaList from './TipoNotaEntradaList.vue';
import TipoNotaEntradaListHeader from './TipoNotaEntradaListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Notas de Entrada' },
      ],
      notasEntrada: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: '',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemTipoNotaEntrada', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getTipsoNotasEntrada();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getTiposNotasEntrada();
    },
    onClickRefresh() {
      this.getTiposNotasEntrada();
    },
    onRemove(item) {
      this.loading = true;
      TipoNotaEntradaService.remover(item.id)
        .then(() => {
          this.$toast('Nota de entrada removida com sucesso', { color: 'success' });
          this.getTiposNotasEntrada();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getTiposNotasEntrada() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      TipoNotaEntradaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.notasEntrada = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxTipoNotaEntradaList: TipoNotaEntradaList,
    pxTipoNotaEntradaListHeader: TipoNotaEntradaListHeader,
  },
};

</script>
